import dayjs from "dayjs";
import { z } from "zod";

const requiredFieldMessage = { message: "Обязательное поле" };

const AuthorizedRepresentative = z.object({
  user: z.object({
    surname: z.string().optional(),
    firstName: z.string().optional(),
    organization: z.string().optional(),
    position: z.string().optional(),
    userId: z.string(requiredFieldMessage).min(1, "Обязательное поле"),
    userCompanyHistoryId: z.string(requiredFieldMessage).min(1, "Обязательное поле"),
  }),
});

const JournalKeepers = z.object({
  company: z.object({
    companyName: z.string().optional(),
    companyId: z.string().nullable().refine((val) => val !== null, {
      message: "Обязательное поле",
    }),
    projectParticipantId: z.string().nullable().refine((val) => val !== null, {
      message: "Обязательное поле",
    }),
  }),
  authorizedRepresentativesList: z.array(AuthorizedRepresentative).min(1, "Добавьте хотя бы одного сотрудника"),
});

export { AuthorizedRepresentative };

export const AddRecordSchema = z.object({
  specialJournalName: z
    .string(requiredFieldMessage)
    .max(255, "Максимальная длина — 255 символов")
    .refine((val) => val && val.trim().length > 0, {
      message: "Обязательное поле",
    }),
  specialJournalDate: z.custom<dayjs.Dayjs>(
    (val) => dayjs.isDayjs(val) && val.isValid(),
    {
      message: "Некорректная дата",
    },
  ),
  dateHandover: z.custom<dayjs.Dayjs | null>(
    (val) => val === null || (dayjs.isDayjs(val) && val.isValid()),
    {
      message: "Некорректная дата",
    },
  ).nullable(),
  signer: z
    .string(requiredFieldMessage)
    .refine((val) => val && val.trim().length > 0, {
      message: "Обязательное поле",
    }),
  file: z
    .object({
      file: z.instanceof(File).nullish(),
      id: z.string().nullish(),
    })
    .nullish(),
  journalKeepersList: z.array(JournalKeepers).min(1, "Добавьте хотя бы одну организацию"),
});
